import type { FC } from 'react';
import type { TaskTarget } from '@/model/Task.model';
import { EmptyState } from './EmptyState';
import { type TreatmentGroup } from '@/model/TreatmentGroup.model.ts';
import { ReadOnlyGroupList } from '@/components/UI/GroupList/ReadOnlyGroupList.tsx';

interface TaskTargetContentProps {
  target: TaskTarget;
  targetGroups: Array<TreatmentGroup>;
  emptyMessage?: string;
}

export const TaskTargetContent: FC<TaskTargetContentProps> = ({
  target,
  targetGroups,
  emptyMessage = 'No groups found for this task',
}) => {
  if (target.type === 'animal') {
    return <EmptyState message="This task targets all animals" />;
  }

  if (targetGroups.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }

  return (
    <div data-testid="task-target-groups-container">
      <ReadOnlyGroupList groups={targetGroups} />
    </div>
  );
};
